export default "__VITE_PUBLIC_ASSET__44220b2b__"